import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';

function PopUpTask({ isOpen, onClose }) {
  const [urgency, setUrgency] = React.useState("");
  const [assignTo, setAssignTo] = React.useState("");
  const [shortDescription, setShortDescription] = React.useState("");
  const [detailedDescription, setDetailedDescription] = React.useState("");

  const onSubmit = (event) => {
    console.log("Selected urgency:", urgency);
    console.log("Assign to:", assignTo);
    console.log("Short Description:", shortDescription);
    console.log("Detailed Description:", detailedDescription);
  };

  const handleUrgencyChange = (event) => {
    setUrgency(event.target.value);
  };

  const handleAssignToChange = (event) => {
    setAssignTo(event.target.value);
  };

  const handleShortDescriptionChange = (event) => {
    setShortDescription(event.target.value);
  };

  const handleDetailedDescriptionChange = (event) => {
    setDetailedDescription(event.target.value);
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth='true'
        maxWidth='md'
        open={isOpen}
        onClose={onClose}
      >
        <DialogTitle>Create New Task</DialogTitle>
        <DialogContent>
          <Box
            noValidate
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: 'fit-content',
            }}
          >
            <Grid container spacing={2} style={{margin: '3px'}}>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="max-width">Urgency</InputLabel>
                  <Select
                    autoFocus
                    value={urgency}
                    onChange={handleUrgencyChange}
                    label="maxWidth"
                    inputProps={{
                      name: 'max-width',
                      id: 'max-width',
                    }}
                  >
                    <MenuItem value="Critical">Critical</MenuItem>
                    <MenuItem value="non-Critical">Non-Critical</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    id="assign-to"
                    label="Assign to:"
                    value={assignTo}
                    onChange={handleAssignToChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="short-description"
                  label="Short Description"
                  value={shortDescription}
                  onChange={handleShortDescriptionChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="detail-description"
                  label="Detailed Description"
                  multiline
                  maxRows={4}
                  defaultValue=""
                  value={detailedDescription}
                  onChange={handleDetailedDescriptionChange}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onClose} color="secondary" disableElevation>Cancel</Button>
          <Button variant="contained" onClick={onSubmit} disableElevation>Submit</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export { PopUpTask };
